import { createClient } from '@sanity/client';

export default createClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
  dataset: process.env.REACT_APP_SANITY_DATASET,
  apiVersion: '2025-04-28',
  useCdn: false, // Disable CDN for fresh stats data
  token: process.env.REACT_APP_SANITY_TOKEN,
});
